<template>
  <b-container>
    <b-row class="telemedecine mx-auto">
      Dans le cadre de notre participation aux projets du
      <a target="_blank" href="https://www.psip-smh.fr/">
        &nbsp; Pôle de santé de St Martin d’Hères</a
      >, nous pratiquons des rétinographies (=photo du fond d’oeil) pour les
      diabétiques.
      <b-col md="6">
        <img src="/prisesEnChargeImages/image9.jpg" />
      </b-col>
      <b-col md="6">
        <img src="/prisesEnChargeImages/image26.jpg" />
      </b-col>
      <i>Rétinographes</i>
    </b-row>
    <AccordionText
      v-for="accordion in accordions"
      :key="accordion.id"
      :id="accordion.id"
      :title="accordion.title"
      :text="accordion.text"
    ></AccordionText>
  </b-container>
</template>

<script>
import AccordionText from "../../components/AccordionText";

export default {
  data() {
    return {
      accordions: [
        {
          title: "Définition",
          id: "definition",
          text: `Le diabète est une des principales causes de cécité en Europe, et devient même la première cause de cécité en France avant 65 ans.
La meilleure prévention est l’équilibre du diabète (HBA1C < 7%). Le diabète atteint les petits vaisseaux sanguins, créant une zone d’ischémie. La rétine appauvrie en apport sanguin crée alors une néovascularisation avec de forts risques d’hémorragies, entraînant des décollements de rétines et un oedème rétinien.
<img src="/prisesEnChargeImages/image2.jpg" />

<img src="/prisesEnChargeImages/image24.jpg" />

<i>Néovascularisation (gauche) et oedème maculaire (droite)</i>
`,
        },
        {
          title: "Symptômes",
          id: "symptome",
          text: `Les patients se rendent compte des symptômes à un stade très avancé de la maladie. Pour éviter une prise en charge tardive, un dépistage est nécessaire régulièrement (tous les 1 à 2 ans en fonction de différents paramètres comme l’ancienneté du diabète, le taux d’hémoglobine glycquée Hba1c, la présente d’hypertension artérielle...). 
  <img src="/prisesEnChargeImages/image6.jpg" width=300/>
*Altération de la vision due à la rétinopathie diabétique*
`,
        },
        {
          title: "Traitement",
          id: "traitement",
          text: `Le traitement se fait par photocoagulation laser panrétinienne. Elle est indiquée dans tous les cas de rétinopathie diabétique proliférante avec présence de néovaisseaux péripapillaires ou d’hémorragies pré-rétiniennes ou intra-vitréennes. Ce traitement prévient plus de 60% de la perte d’acuité visuelle.
            <img src="/prisesEnChargeImages/image17.jpg" width=300/>
<i>Traitement laser de la rétinopathie diabétique 
</i>
          `,
        },
        {
          title: "Quand se faire dépister ?",
          id: "depistage",
          text: `La Haute Autorité en Santé préconise depuis décembre 2010, un dépistage de la rétinopathie diabétique :
- tous les 2 ans si le diabète est diagnostiqué, non inulino- traités, HbA1c et Pression Artérielles équilibrées,
- un examen annuel est nécessaire en cas de diabète ou pression artérielle mal équilibrés,
- pour femme enceinte diabétique, un dépistage avant la grossesse, trimestriel et post partum.

Une première consultation de dépistage est recommandée, 3 ans après la découverte d'un diabète de type I, immédiatement lors de la découverte du diabète pour de type II, à partir de l'âge de 10 ans pour un enfant.
            <img src="/prisesEnChargeImages/image32.jpg" height=600/>

`,
        },
        {
          title: "Qui peut bénéficier de ce dépistage ?",
          id: "benefice",
          text: `Cet examen est un dépistage, il faut donc ne pas avoir de rétinopathie diabétique connue. Il est utile pour tous les types de diabète. Il est préconisé chez les patients de moins de 	moins 	de 70 ans (pour éviter les troubles de transparence des milieux oculaires comme la cataracte)
`,
        },
        {
          title: "Comment se déroule l’examen?",
          id: "deroulement",
          text: `
L’orthoptiste réalise des clichés du fond d’oeil sans dilatation préalable. La conduite est donc possible rapidement après l’examen. Les personnes connues pour avoir de très petites pupilles peuvent se faire prescrire au préalable un collyre dilatateur. Dans ce cas la conduite est déconseillée.

Si toutefois les photos n’étaient pas de bonne qualité l’orthoptiste peut être amené à dilater les patients (à condition d’avoir une ordonnance du produit).
Le temps de l’examen dépend de la facilité de la prise des clichés mais il dure en moyenne 15 min
Les photos et la fiche patient (à [télécharger](/questionnaires/fiche_patient_retino.odt) et à compléter pour l’examen) sont ensuite télétransmises à un médecin ophtalmologiste lecteur, qui enverra un compte rendu au médecin prescripteur.
Les envois sont effectués de manière sécurisée

**PRESCRIPTION OBLIGATOIRE :** Dépistage de la rétinographie diabétique (=RD) par rétinographie non mydriatique couleur
Elle peut être complétée de la prescription de TROPICAMIDE 0,5 % collyre sol récip unidose (MYDRIATICUM Unidose) pour anticiper le besoin de dilatation pour faire l’examen, si les personnes sont connues pour avoir de petites pupilles.
Elle est obligatoirement complétée de la fiche patient (à [télécharger](/questionnaires/fiche_patient_retino.odt))`,
        },
        {
          title: "Comment prendre rendez-vous ?",
          id: "rdv",
          text: `
Les rendez-vous se font au cabinet de Saint Martin d'Hères.

Pour toute demande de rendez-vous merci de contacter Véronique Denis au 04 76 59 34 52 ou par mail [veronique.denis@psip-smh.fr](mailto:veronique.denis@psip-smh.fr). Vous pouvez prendre RV également avec votre infirmière ASALEE.
Pour tout renseignement les orthoptistes sont joignables par mail sur [retino.smh@gmail.com](mailto:retino.smh@gmail.com).`,
        },
      ],
    };
  },
  components: {
    AccordionText,
  },
};
</script>

<style scoped>
.telemedecine img {
  max-width: 300px !important;
}
</style>
